module.exports = __webpack_public_path__ + "img/posologie-bertil-synthese-1.4fbac48d.png";